import { addProduct } from "components/Stacker/actions/StackerActions"
import classNames from "classnames"
import { gsap, MotionPathPlugin, CSSPlugin } from "gsap/all"
//import { Draggable } from "gsap/Draggable"
//import MotionPathPlugin from "gsap/MotionPathPlugin"
import isMobile from "components/Stacker/utils/device-check"
import PropTypes from "prop-types"
import { useEffect, useLayoutEffect, useRef, useState } from "react"
import "./AmuletItem.scss"
//import { ReactComponent as RemoveAmulet } from "assets/temp/icons/icon-remove-amulet.svg"
import { getFadedButtonStyles } from "components/DYStackers/styles"
import Draggable from "gsap/Draggable"
import { usePrevious } from "reactHooks"
import { useLocation, useNavigate } from "react-router-dom"
import { AEM_ASSETS } from "components/Stacker/AEMConstants"

gsap.registerPlugin(MotionPathPlugin, Draggable, CSSPlugin)

export const AmuletItemF = ({
  delay,
  duration,
  id,
  isRearrange,
  isVehicle,
  scale,
  src,
  isNew,
  to,
  onComplete = () => null,
  onDrag,
  onDragEnd,
  getEdge,
  getAnimatedTo,
  pathId,
}) => {
  const [isDragging, setDraggingState] = useState(false)
  //const [edge, setEdge] = useState(0)
  const [isLoaded, setIsLoaded] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const drag = useRef(null)
  const amuletRef = useRef()
  const prevTo = useRef()
  const prevIsReady = useRef(false) // usePrevious(isLoaded)
  const imgRef = useRef()
  const position = useRef(-1)
  const isAnimating = useRef(false)

  const start = (from = 1) => {
    // if (isAnimating.current) {
    //   return
    // }
    const rotation = from > to ? 180 : 0
    console.log("starting amulet item")
    gsap.to(amuletRef.current, {
      duration: 0,
      scale,
      autoAlpha: 1,
      //immediateRender: true,
    })

    gsap.to(amuletRef.current, {
      ease: "power4.out",
      delay,
      duration,
      scale,
      immediateRender: true,
      motionPath: {
        align: pathId,
        alignOrigin: [0.5, 0.07],
        autoRotate: rotation,
        end: to,
        path: pathId,
        start: from,
        fromCurrent: false,
      },
      onComplete: () => {
        isAnimating.current = false
      },
    })
    console.log(`animating ${id} from ${from} to ${to}`)
    position.current = to
  }

  const move = (newTo) => {
    // if (isAnimating.current) {
    //   return
    // }
    if (newTo === getAnimatedTo(id) && !(newTo == 0.5 && !isRearrange)) {
      position.current = newTo
      return
    }
    isAnimating.current = true
    const rotation = position.current > to ? 180 : 0
    const start = position.current
    gsap.to(amuletRef.current, {
      ease: "power4.out",
      delay,
      duration,
      scale,
      autoAlpha: 1,
      motionPath: {
        align: pathId,
        alignOrigin: [0.5, 0.07],
        autoRotate: rotation,
        end: newTo,
        path: pathId,
        start: start, // getAnimatedTo(id),
      },
      onComplete: () => {
        isAnimating.current = false
      },
    })
    console.log(`moving ${id} to ${to}`)
    position.current = newTo
  }

  const findEdge = () => {
    const edge = getEdge()
    const multiplier = isMobile() ? 1.3 : 1.04
    return edge * multiplier
  }

  const update = () => {
    const edge = findEdge()

    //const multiplier = isMobile() ? 1.3 : 1.04
    const edgeMin = 0.05
    const edgeMax = isMobile() ? 0.75 : 0.9

    if (edge <= edgeMin || edge >= edgeMax) {
      return
    }

    isAnimating.current = false

    gsap.to(amuletRef.current, {
      duration: 0,
      scale,
      motionPath: {
        align: pathId,
        alignOrigin: [0.5, 0.07],
        autoRotate: true,
        end: edge,
        path: pathId,
        start: edge,
      },
    })
    position.current = edge
    onDrag(id, edge)
  }

  useLayoutEffect(() => {
    if (imgRef.current.complete) {
      setIsLoaded(true)
      //start()
    }
  }, [])

  useEffect(() => {
    const onWindowResize = () => {
      gsap.to(amuletRef.current, {
        onComplete: () => onComplete(),
        duration: 0,
        scale,
        motionPath: {
          align: pathId,
          alignOrigin: [0.5, 0.07],
          end: to,
          path: pathId,
          start: to,
        },
      })
      console.log("resized")
      console.log(amuletRef.current)
    }
    const draggable = Draggable.create(amuletRef.current, {
      type: "top",
      onDragEnd: () => {
        //const multiplier = isMobile() ? 1.3 : 1.04
        setDraggingState(false)
        //start(getEdge() * multiplier)
        //move(to)
        onDragEnd(id)
      },
      onDragStart: () => setDraggingState(true),
      onDrag: update,
    })
    drag.current = draggable[0]
    window.addEventListener("resize", onWindowResize)
    return () => {
      drag.current.kill()
      window.removeEventListener("resize", onWindowResize)
    }
  }, [to])

  useEffect(() => {
    if (isRearrange) {
      drag.current.enable()
    } else {
      drag.current.disable()
    }
    move(to)
  }, [isRearrange])

  useLayoutEffect(() => {
    if (isNew) {
      if (isLoaded || imgRef.current.complete) {
        start()
      } else {
        prevIsReady.current = false
      }
    }
  }, [isNew])

  useEffect(() => {
    if (!prevIsReady.current && isLoaded) {
      prevIsReady.current = true
      prevTo.current = to
      start()
      return
    }
  }, [isLoaded])

  // useEffect(() => {
  //   if (!isDragging) {
  //     move(to)
  //   }
  // }, [isRearrange])

  useEffect(() => {
    if (!isLoaded) {
      return
    }
    if (prevTo.current !== to) {
      if (!isDragging) {
        //start(prevTo.current)
        move(to)
        prevTo.current = to
        return
      }
    }
    // if (to === 0.5 && prevTo.current === 0.5) {
    //   start(to)
    // }
    // prevTo.current = to
  }, [isDragging, isLoaded, to])

  // useLayoutEffect(() => {
  //   // if (isLoaded) {
  //   //   if (to !== prevTo) {
  //   //     if (!isDragging) {
  //   //       start(prevTo ?? to)
  //   //       return
  //   //     }
  //   //   }
  //   // }
  //   // if (!isDragging && (isLoaded || imgRef.current.complete)) {
  //   //   if (prevTo) {
  //   //     move(to)
  //   //   } else {
  //   //     start()
  //   //   }
  //   // }
  //   if(to)
  // }, [isDragging, isLoaded, prevTo, to])

  // useEffect(() => {
  //   if (to !== prevTo) {
  //     if (!isDragging) {
  //       start(prevTo ?? to)
  //       return
  //     }
  //   }

  //   // if (!prevIsReady && isLoaded) {
  //   //   start()
  //   //   return
  //   // }

  //   // if (to === 0.5 && prevTo === 0.5) {
  //   //   start(to)
  //   //   return
  //   // }
  // }, [prevTo, to])

  const amuletAnimClasses = classNames("amulet-anim", {
    "d-inline-block": isLoaded,
  })
  const removeAmuletClasses = classNames("btn btn-icon remove-amulet", {
    "remove-amulet-vehicle": isVehicle,
  })

  return (
    <div id={`container-amulet${id}`} className="container-amulet">
      <div
        id={`amulet${id}`}
        className={amuletAnimClasses}
        style={{ scale }}
        ref={amuletRef}
      >
        {isRearrange && (
          <button
            className={removeAmuletClasses}
            onClick={() => addProduct(id, location, navigate)}
          >
            {/* <RemoveAmulet alt="Remove" style={getFadedButtonStyles()} /> */}
            <img
              alt="Remove"
              style={getFadedButtonStyles()}
              src={`${AEM_ASSETS}/temp/icons/icon-remove-amulet.svg`}
            />
          </button>
        )}
        <div className="amulet-anim-img-container">
          <div className="amulet-anim-img">
            <img
              alt="Amulet"
              src={src}
              ref={imgRef}
              onLoad={() => {
                setIsLoaded(true)
                //start()
              }}
              height="560"
              width="485"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AmuletItemF.propTypes = {
  delay: PropTypes.number,
  duration: PropTypes.number,
  id: PropTypes.string.isRequired || PropTypes.number.isRequired,
  isRearrange: PropTypes.bool.isRequired,
  isVehicle: PropTypes.bool.isRequired,
  scale: PropTypes.number,
  src: PropTypes.string.isRequired,
  to: PropTypes.number.isRequired,
  isNew: PropTypes.bool,
  onComplete: PropTypes.func,
  onDrag: PropTypes.func,
  onDragEnd: PropTypes.func,
  getEdge: PropTypes.func,
  getAnimatedTo: PropTypes.func,
  pathId: PropTypes.any,
}

export default AmuletItemF
